const PauseIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    {...props}
  >
    <g clip-path="url(#clip0_2052_14613)">
      <path
        d="M9.57422 4H7.57422C7.04379 4 6.53508 4.21071 6.16001 4.58579C5.78493 4.96086 5.57422 5.46957 5.57422 6V18C5.57422 18.5304 5.78493 19.0391 6.16001 19.4142C6.53508 19.7893 7.04379 20 7.57422 20H9.57422C10.1047 20 10.6134 19.7893 10.9884 19.4142C11.3635 19.0391 11.5742 18.5304 11.5742 18V6C11.5742 5.46957 11.3635 4.96086 10.9884 4.58579C10.6134 4.21071 10.1047 4 9.57422 4Z"
        fill="white"
      />
      <path
        d="M17.5742 4H15.5742C15.0438 4 14.5351 4.21071 14.16 4.58579C13.7849 4.96086 13.5742 5.46957 13.5742 6V18C13.5742 18.5304 13.7849 19.0391 14.16 19.4142C14.5351 19.7893 15.0438 20 15.5742 20H17.5742C18.1047 20 18.6134 19.7893 18.9884 19.4142C19.3635 19.0391 19.5742 18.5304 19.5742 18V6C19.5742 5.46957 19.3635 4.96086 18.9884 4.58579C18.6134 4.21071 18.1047 4 17.5742 4Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_2052_14613">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0.574219)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default PauseIcon;
